// @ts-nocheck

import dash_api from '../support/dash_api';
import { ReduxAsyncAction } from '../support/utils';

/**
 * Deletes the persona for the device id of the app level
 * @return {Object} action
 */
const DeleteDeviceIdPersona = new ReduxAsyncAction('DELETE_DEVICE_ID_PERSONA');
DeleteDeviceIdPersona.registerRequest(function (deviceId) {
  return dash_api.delete(`/v1/persona-service/gdpr?device_id=${deviceId}`);
});
export const DELETE_DEVICE_ID_PERSONA = DeleteDeviceIdPersona.constants;
export const deleteDeviceIdPersona = DeleteDeviceIdPersona.request;
